import { createContext } from '@lit/context'

/** Close behavior a Modal provides to composed close controls. */
export interface ModalContext {
  requestClose: (trigger?: Event) => void
}

/** Context composed Modal parts use to coordinate with their nearest Modal. */
export const modalContext = createContext<ModalContext | undefined>(
  Symbol('nord-modal'),
)
